import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';
import { useUserStore } from '~providers/userStore/zustand';

type Answer = {
  question: string;
  answer: string;
};

type SubmitOnboardingAnswersRequest = {
  answers: Answer[];
};

export function useSubmitOnboardingAnswers(userId: string) {
  return useMutation<void, Error, SubmitOnboardingAnswersRequest>(async data => {
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}users/${userId}/onboarding-answers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Failed to submit answers');
    }

    return response.json();
  });
}
